// extracted by mini-css-extract-plugin
export default {"link":"BaseLink_link__fT+Oz","link1":"BaseLink_link1__5uEJW"};